import { render, staticRenderFns } from "./VerFacturaciones.vue?vue&type=template&id=3bdaffb8&"
import script from "./VerFacturaciones.vue?vue&type=script&lang=ts&"
export * from "./VerFacturaciones.vue?vue&type=script&lang=ts&"
import style0 from "./VerFacturaciones.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports